import RHFDatePicker from '../../../../../components/hook-form/RHFDatePicker';

const FormInputDate = ({ name, data, disabled, ...props }) => {
  return <RHFDatePicker name={name} label={data?.label} disabled={disabled} {...props} />;
};

export default FormInputDate;
